import Keycloack from 'keycloak-js';

const keycloack = new Keycloack({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export const keycloakInitConfiguration = {
  onLoad: 'login-required',
  checkLoginIframe: false,
};

export default keycloack;
